import React from "react"
import HorizontalScroll from "react-scroll-horizontal"
import ReactResizeDetector from "react-resize-detector"
import ReactFullpage from "@fullpage/react-fullpage"
import { Scrollbars } from "react-custom-scrollbars"
import { Link, navigate } from "gatsby"
import posed from "react-pose"
import VisibilitySensor from "react-visibility-sensor"
import { detect } from "detect-browser"
import { isIE } from "react-device-detect";

// import Anime from "react-anime"
// import { throttle, debounce } from "lodash"
// import Brush from './Brush/index'

import banners from "../components/banner-imports"

import ArrowSvg from "../utils/svg/pinkArrow.svg"

import gray_default from "../../content/assets/gray_default.jpg"
const phoneWidth = 768
const tabletWidth = 950
const browserHandler = detect()

export class BrushAnimation extends React.Component {
  constructor(props) {
    super(props)
    this.strokeTitle = React.createRef()
    this.state = {
      ScrollCount: null,
      height: null,
      width: null,
      isTablet: null,
      imageloaded: false,
    }
  }
  render() {
    const onVisibleChange = isVisible => {
        try {
            if (isVisible) {
                this.strokeTitle.current.classList.add("stroke-path")
                this.strokeTitle.current.classList.remove("custom-hidden")
              } else {
                this.strokeTitle.current.classList.remove("stroke-path")
                this.strokeTitle.current.classList.add("custom-hidden")
              }
        }
        catch(err) {
            // console.log(err);
        }
    }

    return (
      <VisibilitySensor onChange={onVisibleChange}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-style"
          viewBox="0 0 363 91"
        >
          <defs>
            <clipPath id="brush3_svg__a">
              <path d="M191.4 23.7c.3-.3 1.5-.5 1.7-.9 1.4.4 1.9.3 4.5-.1-.4.9-3.5.2-6.2 1zm-1.9-.8c-2.4 0-6.8 1.8-9 .7 4.3-.6 6.1-.8 7.1-1.7 1.1.2 1.7.5 4.5 0-.9.4-2.4.7-2.6 1.2-1 .1-.5-.2 0-.2zm29.5-3c-1.3-.5-.1-.7 1.8-.8 1.9-.1 4.6 0 6.2-.3-.6.3-2.1.3-1.8.8-1.8-.1-5.5-.7-6.2.3zm-49.1 47.2c8-2.4 17.6-2.7 26.6-4.2-3.6 1.3-19.2 2.5-26.6 4.2zM70.2 47.8c-1.1.2-2.2.3-1.9-.2-5.3.8-6.8 2-11.7 2.8.4.5 1.1.9 2.9.8 1.5-.9 4.3-2.4 7.2-1.9.1-.5.5-.9 1.7-1.3 0 .3 1.6.1 1.8-.2zm-14.5 2.8c-3.9.5-2.3 2 .1 1 .1.3.4.5 1.9.2.2-.8-2.2-.5-2-1.2zm42.9-8.7c1.8 0 7.7-1.2 7.9-2.1-1.9.7-7.4 1.1-7.9 2.1zm11.5-2.7c3.9-.8 12.2-2.4 10.5-2.9-3.3.9-8.6 1.7-10.5 2.9zm-11-.1c-1.8 1.4-7.1 2.5-11.9 3.5-4.8 1-9.1 1.9-9 3.1 4-1.1 3.3-1 7.2-1.3-.9-1.4 3.2-.9 4.2-2 1.2-.2.9.3 1.9.2 2.8-.9 2.4-1.4 7-1.7.8-1.3 6.1-1.3 9.6-2.6l-.1-.5c-.5.1-1.1.1-.9-.1-2.4.6-3.1 1.4-6.1 2-.1-.4-2.5.1-1.9-.6zm42.5-8.3c-.1-.7-2-.7-2.9-1l-4.5.7c-.1.8-3 1.2-5.2 1.8-.4-.5-1.9-.7-.2-1.4-1.8 1-4.6 2.4-2.3 2.6-1.8-.2-2 .6-3.5 1.1 1.1 0 10.7-1.7 4.4-1.2 6.2-.7 8.7-2.1 14.2-2.6zm-7.3 56.9c.9-.9-6.8-.1-7.2.2 3.3 0 2.7.1 7.2-.2zm173-81.8c-1.1-.2-2.3-.4-3.4-.5l-1.8-.2-.9-.2-.8-.1c.1.1.4.1.9.2s1.2.2 2 .3c1.5.3 3.5.6 5.4.9 3.8.6 7.5 1.3 8.1 1.1-4.8-1-7.4-1.4-9.5-1.5zm13 44.3c-5.7-.5-20.2 1.4-26.2 2.4 9.5-.6 16.4-1.7 26.2-2.4zm-57.6 5.6c2.1-.1 9.5-.5 12.5-1.6-4.3.7-23 2.3-12.5 1.6zm-11 21.9c8.1.1 27.4-2 38-1.6-13.8.8-21.5 1.3-36.2 2.4.1.5 3.8-.2 5.4-.1-44.8 3.4-73.7 5.1-111.2 7.7-2.9.4-1.6.9-2.6 1.1l-19 1.3c.9-1.3-2.7-1-4.6-1.4-2.5 0 .7 1.1-1.7 1.1.2.5 2.3.4 4.5.2-12.3 1.1-27.4 2.2-43.6 2.5-4.1 0-8.2.1-12.4 0-2.1 0-4.2-.1-6.3-.2-2.1-.1-4.3-.2-6.2-.3-1.9-.2-3.6-.4-4.9-.8-1.3-.4-2.4-1-2.9-1.5-.6-.6-1.1-1.4-1.3-2-.1-.3-.1-.4-.1-.4h-.1.1v-.1c-.2-.2 0-.3.3-.6.4-.3.9-.7.4-.9 1-.3 2.2-.7 3.7-1.1 1.5-.4 3.1-.9 4.6-1.4l9-3c6.1-2 12.2-4.1 19.1-5.5-2.1-.3 3.2-.7 5.9-2.2 2.2-.5 1.1-.1 1 .3 24.9-6.1 51.1-10.6 75.5-14.4 24.4-3.7 46.9-6.6 64.8-9.1 7.3-.3 15.3-1 25.2-2.7 16.1-1.5 34.1-2.6 48.6-5.6.4.4-.7.5-1.8.6 7.4-.3 19.9-1.4 28.9-2.7 2-.2-1.2-.5-.1-1.2 1.9-.3 6-.3 6.3-.9 4.2.3-5.2.6-3.5 1.4 3 0 6.1-.4 9.3-1.1.8-.2 1.6-.4 2.5-.7.2-.1.5-.2.7-.3.2-.1.3-.1.5-.2s.3-.2.7-.4l.2-.2s.1 0 .1-.1c.1-.1.1-.2.2-.2.3-.3.5-.9.5-.9.1-.3.2-.6.2-.9.1-.6-.1-1.2-.2-1.7-.4-.9-.8-1.4-1.2-1.8-.4-.4-.8-.7-1.2-.9-.8-.5-1.5-.9-2.2-1.2-3.2-1.9-6.5-3.2-10-4.4-3.4-1.2-6.9-2.2-10.5-3.2-7.1-1.8-14.3-3.3-21.5-4-1.8-.2-3.6-.3-5.3-.4-1.7-.1-3.5-.2-5.2-.3-1.7-.1-3.4-.2-5-.3-1.7-.1-3.3-.1-4.9-.1-3.2-.1-6.3-.2-9.2-.3-2.9 0-5.7-.1-8.3-.1-1.6.6 4 .6.9.8-1.5-.1-1.7.1-1.8.4-3.3-.3.4-.7-1.8-1.3-2.2 0-4.2.1-6.1.2-1.9.1-3.7.1-5.4.2-1.7.1-3.3.1-4.8.2s-3 .2-4.4.2c-2.8.2-5.5.3-8.1.6-2.7.3-5.4.6-8.4 1.1 2-1-1.6.1-2.7-.4-3.5.8-5.6 2-11.6 2.4-.3-.8 5.7-.8 8-1.7-6.3.4-12.2.7-18.2 1.5-3 .4-6 .8-9.1 1.4-3.1.6-6.2 1.3-9.5 2.2 1 .9 5.4-.9 5.5.2-3.1.8-5.8 1.3-8.5 1.8s-5.4.7-8.4.8c.2-.3 1.8-.4 1.7-.7-.1.2-2.6.6-5 1.1-2.4.5-4.8 1.1-4.6 1.8-4.4-.1-8 .8-8.8 2.4-2.4 0-6.1.6-7.3.1-1 .4.3.5-2.6 1.1 3.6.6 6.1-.2 13.4-1.4 1.6-.7-.6-.4-.2-1.2 3.9-.3.9.8 4.6.6 6.9-1.2 7-1.9 14.2-2.7-1.7 1.9-9.9 2.3-15 3.3-1.3.6-6.3 2-6.1 2-1.2.7-1.9 0-1-.6-8.3 1.5-8.3 2.6-9.5 3.8-2.6.1-3.1-.3-2-1.2-7.1 1.7-18.7 2.8-20 5.8-.9 0-1-.4-2.7 0-1.3 1.4-7.2.9-8.6 2.9-3.6-.4-9.5 1.7-13.2 2.7l-.2-1.2c-5.3 1.2-9.3 2.4-14 3.7 3 .6 8.3-2.1 13.3-2.8-13.2 4.2-25.5 7.4-40.8 11.1 9.2-2.8 17.1-4.6 26.8-7.4-2.2-.2-4.4 1.3-6.3.9-2.5 1-6.9 2.3-11.2 3.3-4.3 1-8.4 1.8-10.4 1.9-2.8 1.8-11.3 3.1-19.4 4.8-3.4-.1 2.7-.8 2.7-1.2-.4-.8-4.4 1.2-3.8-.1 4.4-.5 4.2-.7 5.7-.1-.1-1.1 2.6-.5 2.7-1.5 2-.3 1.8.1 2 .5.6-.7.8-1.6 4.5-1.6-.2-.7-2.4-.5-4.6-.1-2.2.4-4.5 1.1-4.7 1.5-4.8.2-10.6.8-15.2 1.8-2.1.1-2.1-.5-2-1.1-.3.3-7.7-.7-5.6-1.6-6.1-.7-7.4-.3-12.5-1.1 2.9-.6-.8-.3 1.9-1.2-.8-.7-3.8-.9-5.7-1.3-.7-1.1 3.1-.9 3.8-1.6-4.1-.1 1.4-1-4.7-.9 1.5-.5 4.4-.8.1-1.2-.7-.9 3.6-.4 3.8-1.1-.1-.9-2.6-1.2-2.7-2-.4-.6 1.7-.5 1-1.2 8.2-1.2 17.3-2.7 26.9-4.7 9.6-1.9 19.8-4.2 30.2-6.6 8.1-1.9 16.4-3.9 24.8-6 8.4-2 17-4.1 25.7-6.1 17.4-4 35.3-7.7 53.6-10.7 22-3.7 47.9-6.8 71.4-7.9 20.1-1 38.1-.9 55.2.1 2.1.2 4.3.3 6.4.4 1.1.1 2.1.1 3.2.2s2 .1 3.3.3c4.7.5 9 1.2 13.2 2 4.2.8 8.4 1.7 12.6 2.8 4.2 1.1 8.3 2.2 12.7 3.8 2.2.8 4.4 1.6 6.9 2.7 1.3.6 2.6 1.2 4.2 2.2.8.5 1.7 1.1 2.8 1.9.3.2.6.4.9.7.3.3.6.6 1 .9.4.4.7.7 1.1 1.2.2.3.4.5.6.8l.3.4.4.5c.2.4.5.7.7 1.1l.7 1.4.3.8c.1.3.2.7.4 1 .1.3.2.7.3 1 .1.4.2.6.2 1.1.2.8.2 1.7.3 2.5 0 .9 0 1.9-.1 2.8-.1.9-.3 1.8-.6 2.7-.1.4-.3.9-.5 1.3-.1.3-.6 1.3-.9 1.8-.4.7-.8 1.3-1.3 1.9-.5.6-1 1.2-1.5 1.7-.3.2-.5.4-.7.6-.5.4-.9.8-1.5 1.1-.2.2-.5.3-.8.5l-.4.2-.7.4-.7.4-.5.2-.9.3-.6.2-.6.2-.9.2c-1 .3-1.8.4-2.5.6l-2 .4c-2.5.4-4.7.7-6.9 1-8.8 1.1-17.4 1.9-26.6 2.9-18.3 1.8-38.2 3.7-61.1 6.1-36.6 4-80.5 10.2-117 16.2-16.7 2.8 2.7-1 6-1.5 18.4-3.3 35.6-5.8 52.8-8.1 17.2-2.3 34.6-4.4 53.7-6.7-4.5.1-13.1 1-18.8 1.9 15.6-2.4 33.2-4.4 51-6.1 17.8-1.8 35.8-3.2 52.4-5-1.2.8-3.4.5-7.3 1.1 6.4-.2 11.9-.8 18.1-1.7 1.6-.2 3.2-.5 5.2-.9.5-.1 1-.2 1.7-.4l1-.3.6-.2.8-.2.4-.1.6-.2.6-.2.5-.2.5-.3.5-.3.3-.1.4-.2c.7-.5 1.5-1 2.1-1.5l.2-.2.3-.3c.4-.4.8-.8 1.1-1.2.7-.9 1.3-1.8 1.8-2.8.1-.2.2-.5.4-.7l.2-.4.2-.5c.1-.3.2-.6.3-1 .4-1.3.6-2.6.6-4 0-.7 0-1.3-.1-1.9-.1-.6-.2-1.3-.3-1.8-.1-.5-.3-1-.4-1.5-.2-.5-.4-1-.5-1.4-.2-.4-.3-.7-.5-1.1l-.3-.5-.2-.4c-1.4-2.3-2.6-3.4-3.5-4.2-.9-.8-1.7-1.4-2.4-1.9-1.4-1-2.6-1.6-3.7-2.2-2.2-1.1-4.2-2-6.3-2.8 1 .7 2.2 1.3 3.6 2 1.5.7 3.1 1.4 5.4 2.8.6.4 1.3.8 2 1.4.8.6 1.7 1.3 2.9 2.6.3.4.6.8 1 1.2.4.5.7 1.1 1.1 1.6.2.4.4.7.6 1.1l.3.3c.1.2.2.4.3.7.2.5.3 1 .5 1.6.1.5.3 1.1.4 1.8.1.7.1 1.3.1 2s-.1 1.5-.2 2.2c-.1.7-.3 1.4-.5 2.1-.1.4-.2.7-.3 1l-.2.5-.1.2-.2.4c-.1.3-.3.5-.4.8-.6 1-1.3 2.1-2.1 2.9l-.6.6-.3.3-.5.5-1.2.9-.6.4-.4.2c-.7.4-1.7.9-2 1l-.7.3-.5.2c-.3.1-.7.2-.9.3l-.7.2-.6.1c-.8.2-1.4.3-2.1.4-1.2.2-2.4.4-3.6.5-1.6.2-3.7.6-3.9.2l3.9-.5c1-.2 2.1-.4 3.3-.6.6-.1 1.2-.3 2-.4.4-.1.8-.2 1.3-.3l.4-.1.5-.2.5-.2.7-.3.8-.3 1.2-.6.3-.2.5-.3 1.2-.9c.2-.2.4-.3.6-.5l.3-.2.5-.5c.9-.9 1.7-1.9 2.3-3.1.2-.3.3-.6.4-.8.1-.3.3-.6.3-.6l.2-.5c.1-.4.2-.7.4-1.1.2-.7.4-1.5.4-2.3.1-.8.1-1.6.1-2.3 0-.7-.1-1.4-.2-2.1-.5-2.5-1.5-4.4-2.2-5.5l-.6-.9-.5-.7c-.4-.5-.7-.8-1-1.1-1.2-1.2-2.2-1.9-3-2.5-.8-.6-1.6-1-2.2-1.4-2.7-1.5-4.9-2.3-7-3.2-2.1-.8-4.2-1.5-6.2-2.1-8.1-2.5-15.9-4.3-23.9-5.8-4-.7-8.1-1.3-12.4-1.7-3.8-.3-7.6-.5-11.4-.8-1.9-.1-3.7-.2-5.6-.2-1.9 0-3.7-.1-5.5-.1-1.8 0-3.6-.1-5.4-.1-1.8 0-3.6 0-5.3.1 10.3.2 21.4 1.1 33 2.1 6.4.6 12.4 1.7 18.4 2.9 6 1.2 12.1 2.6 18.3 4.3-.7 0-1.3 0-.2.5 2.7.9 5.4 1.8 8.3 3.1 1.5.7 3 1.4 4.8 2.4.9.6 1.9 1.2 3.1 2.2.3.2.7.6 1 .9l.6.6c.2.2.4.4.6.7.2.3.4.5.7.8.3.4.5.7.7 1.1l.2.3.2.4c.1.3.3.5.4.8.1.3.2.5.3.8.1.3.2.7.3 1 .1.3.2.7.3 1 .1.4.2.8.2 1.3.1.4.1.9.1 1.3v1.4c-.1 1-.2 1.9-.5 2.8-.1.5-.3.9-.5 1.3l-.2.4-.2.5c-.2.3-.4.7-.6 1-.4.7-.9 1.3-1.4 1.8l-.4.4-.3.3-.3.3c-.2.2-.5.4-.7.6-.2.2-.5.4-.8.5-.2.2-.6.4-.6.4-.5.3-1 .5-1.5.8-.6.2-1.3.5-1.6.6l-.6.2-.5.1-.8.2c-.5.1-.9.2-1.4.3-1.7.3-3 .5-4.4.7-2.7.4-5.2.7-7.7 1-10 1.1-19.5 2-28.7 3 6.2-.8 12.4-1.5 18.8-2.3 3.2-.4 6.4-.8 9.7-1.2 3.3-.4 6.5-.8 10.2-1.5.9-.2 1.9-.3 3.1-.6.3-.1.6-.1 1-.3l.6-.2.8-.2.5-.2.6-.2.3-.1.5-.2c.3-.2.6-.3.9-.5l.3-.2.5-.3c.3-.2.6-.4.9-.7l.4-.4.2-.2c.1-.1.3-.3.5-.4.6-.7 1.2-1.4 1.7-2.3.2-.4.5-.8.7-1.2l-.2-.3.1-.2c.1-.3.2-.5.3-.8.2-.6.3-1.1.4-1.7.2-1.2.2-2.4.1-3.4-.1-.5-.1-1.1-.2-1.6-.1-.4-.2-.9-.4-1.3-.6-1.7-1.2-2.7-1.8-3.6-1.2-1.7-2.1-2.5-2.9-3.2-1.6-1.3-2.8-2-3.8-2.6-2.2-1.2-4-2-5.8-2.7-1.8-.7-3.6-1.3-5.3-1.9-6.9-2.3-13.7-3.9-20.8-5.3 6.8 1.8 13.7 3.5 21.3 6.1 1.9.6 3.9 1.4 6 2.3 1.1.4 2.2.9 3.3 1.6 1.2.6 2.5 1.3 4.2 2.6l.7.5.8.7c.3.3.6.6.8.9l.9 1.2c.2.3.4.5.5.8l.2.4.3.5c.2.4.4.7.5 1.1.2.4.4 1 .5 1.5.1.3.1.5.2.8.1.3.1.6.1.9.1.6.1 1.2.1 1.9 0 1.4-.3 2.7-.8 4l-.1.2-.1.3c-.2.5-.5 1-.8 1.5-.3.5-.6.9-1 1.4-.2.2-.4.4-.5.6l-.3.3-.2.2c-.6.6-1.4 1.1-2.1 1.6-.7.4-1.6.8-1.9.9l-.7.2-.5.2-.5.1-.4.1c-1 .3-1.6.4-2.3.5-2.6.5-4.7.7-6.9 1-2 .1-1.8.5-1.8.9-6.2.3-12.1.8-18.1 1.3-5.9.5-11.8 1.1-17.5 1.6-43.2 3.8-83.5 7.9-124.7 13.8-20.6 3-41.5 6.4-62.9 10.8-10.7 2.2-21.5 4.7-32.5 7.7-5.5 1.5-10.9 3.1-16.4 4.8-2.7.9-5.4 1.8-8.2 2.7-1.3.5-2.6 1-4 1.4-1.1.4-1.9.8-2 .9 0 0 0 .1-.1 0-.4-.6-.7-1.1-1.1-1.5l-.5-.6c-.1-.2-.3-.4-.5-.6-.3-.3-.5-.6-.8-.9-.2-.2-.5-.4-.6-.6-.1-.1-.4-.3-.4-.3-.1 0-.1-.1-.2-.1h-.1l-.5-.2s.4.2 1.3.1c.8 0 2-.4 2.7-.8.6-.3.8-.5.6-.4-.1.1-.2.2-.4.5-.1.1-.2.3-.3.4l-.1.1c-1.5 2.3 2-3.1 1.7-2.6.1.2.7.6 1.9.8 1.5.3 4 .4 6.8.4h8.2c5.4 0 10.5 0 14.8.7 3.2-.2 10.6-.2 7.1.1-7 .6-13.8.7-20.1.5-3.1-.1-6.2-.2-9.1-.4-1.4-.1-2.8-.2-4.2-.2-1.3-.1-2.3-.2-3.2-.3-.9-.1-1.6-.3-2.1-.4-.3-.1-.4-.2-.6-.2 0 0-.1-.1-.2-.1H51c-.5.7 1-1.6-1.1 1.6v-.1l.1-.1c.3-.4.5-.6.6-.8l-.1.1c-.3.3-1.5.8-2.6 1-.1 0-.3 0-.4.1h-1.1c-.3 0-.6-.1-.5-.1l.4.2s.1 0 .1.1c.2.1.3.2.5.4.5.4 1.1 1 2.1 2.2.2.2.5.6.7.9 0 0 .1-.1.2-.1.2-.1.5-.2.8-.4.4-.2.9-.4 1.4-.6l1.9-.7c10.3-3.7 20.9-6.8 31.5-9.5 21.2-5.4 42.4-9.3 62.6-12.8-17.6 2.3-35.5 5.7-52.6 9.9-8.6 2.1-16.9 4.3-24.9 6.8-4 1.2-7.9 2.5-11.7 3.7-1.9.6-3.8 1.3-5.6 2-1.9.7-3.2 1.2-3.6 1.4-.1 0-.1 0-.1.1l-.5-.6c-.1-.2-.3-.4-.4-.5-.3-.4-.5-.6-.8-.9-.5-.5-.8-.8-1.1-1-.1-.1-.2-.1-.3-.2h-.1l-.5-.2c-.1-.1.1.1.7.1s1.4-.1 2.1-.3c.8-.2 1.4-.6 1.7-.7.3-.2.2-.2 0 .1-.2.2-.3.4-.5.7l-.1.1v.1l.8-1.2h.1l.1.1c.2.1.5.2.8.4.8.2 2 .5 3.5.6.8.1 1.6.1 2.5.2.9.1 1.9.1 2.8.2 3.7.2 7.3.3 10.6.5 15.1.6 30.5-.1 46.1-1.1 15.7-1 31.5-2.2 47.3-3.3 31.6-2.3 63.3-4.4 94.8-5.4-3 .4-5.8.5-7.5.8zM139.1 32.6c1.6-.3 1.8 1.1-.7 1.1.1-.2.9-.4.8-.6-4.1.2-1.1 1.1-4.3 1.4 2.1-1.3-2.3.4-5.4.6 3.3-1.2 6.8-1.8 9.6-2.5zm57.5-11.8c1.5.3 3.7-.5 7.2-.6-2.7 1.1-6.3 1.2-7.9 2.1-2.7-.1 0-1.2.7-1.5zm16.1-1c.8-.1.9 0 .9.2 1.4-.5 1.9-1.7 4.4-1.2 0 .6-3.8.5-2.6 1.4-1.8.1-2.8 0-2.7-.4zm-3.6.5c-1.9-.2 4-1.7 5.3-1.3 0 .7-3.9.8-5.3 1.3zm15.2-2.3v.7c-1.6 0-4.5.4-3.6-.3 1.7-.1 1.9-.4 3.6-.4zm21.6-.9c1 0 .6.5 1.8.5-1.1.5-5.4.2-6.3.8-2.4-.5 2.5-1.2 4.5-.8v-.5zm-6.3.6c-1.6-.2-8.5 0-9 1-1.4-.5-1.9-.4-4.5-.1-.7-.6 1.8-.6 1.8-1 4.6.5 10.4-1.4 11.7.1zm62.9 1.1c3.4.3.9 1.3 1.5 1.9-2.6-.4-2.6-1.7-1.5-1.9zm33.3 6.8c-1.3-.1-3.4-.7-6.1-1.6.7-.3 5.2 1 6.1 1.6zm-66.4-10.8c-.5.2-1 .4-.9.7-.8-.6-3.8-.3-6.4-.2-2.6.1-4.6.2-3.5-.9 3 1.3 8-.5 10.8.4zm75.8 15.3c-.8-.4-2.3-1.1-4.1-1.8-1.8-.7-3.8-1.3-5.7-1.7 1.4.1 3.1.5 3.7.2 1.6.8 2.8 1.2 3.8 1.7 1 .3 1.9.8 2.3 1.6zm-65.9-15.2c.7.2 1.5.3 2.7.4.6.7-1.8.4-1.9.9-1.5-.4-2.2-1.1-.8-1.3zm-6.3-.2c-.1-.5 3.2.1 4.5 0-.4.4-2 .5-1.9 1.1-2.8-.3-1.6-.9-2.6-1.1zm18.1 22.9c1.2-1 7.9-1 10.8-1.6-2.2 1.4-5.7.8-10.8 1.6zm-3.4 3.4c.7-.3.9-.6.8-1l5.4-.4c-.6 1.2-3.5.6-6.2 1.4zm-99.2 43.1c-8.2 1.4-23.1 1.5-40.7 3 8.2-1.1 28-2 40.7-3zm-38.3-2.8c-10 1.4-12.1.5 0 0zm-30.7 2.1c-8.6 1.2-12 .5 0 0zm145.6-30.3c-.5 1.1-8.1 1-11.6 1.5-4.2 0 10-.8 11.6-1.5zM212.5 61c1.8-.9 9.8-.8 11.6-1.7 2.3.5-10.5 1.7-11.6 1.7zm-5.3 1.1c-.8.1-.8 0-.9-.1-13 2-.3-1.3.9.1zm-78.6 11.8c8.2-2.2 11.7-1.8 0 0zm14.8-2.8c6.1-1.2 18.5-4 23.8-3.6-7.9 1-18.5 2.8-23.8 3.6zm-87.3 9c1.1.1 1.8 0 1.7 0 0 0-.7-.1-1.5-.2s-1.6-.2-2-.3c-.2-.1-.4-.1-.4-.1l-.1.2c-.2.5-.3.8-.5 1.2l-.3.6c-.1.2-.2.4-.3.5-.1.1-.1.2-.2.4l-.1.1-2.1 3.2.1-.2c.3-.4.6-.7.7-.8.2-.2-.3.3-1.4.7-1 .4-2.1.5-2.6.5-.6 0-.7-.1-.7-.1s.2.1.8.1c.5 0 1.3-.1 2.1-.3.7-.2 1.4-.6 1.7-.7.3-.2.2-.2-.1.1-.2.2-.3.4-.5.7v.1l2.1-3.2.1-.1.1-.2.3-.6.4-.8.3-.8h.1c.4-.2 1.3-.1 2.3 0z"></path>
            </clipPath>
          </defs>
          <path
            ref={this.strokeTitle}
            className="stroke-path"
            clipPath="url(#brush3_svg__a)"
            d="M-1.3 43.2c20.7 20.2 103.2-22.9 220.4-33C295 3.7 343.5 20.4 343.5 20.4s56.5 22.3-69 28.5c-121.9 6-223.2 35.7-223.2 35.7S26 97.4 289.8 76.2"
            strokeWidth="22px"
            fill="none"
            stroke="rgb(234,23,139)"
          ></path>
          <text
            textAnchor="left"
            className="title-animated-style"
            x="0"
            y="65"
            stroke="none"
            fill="#fff"
            fontWeight="500"
          >
            {this.props.title}
          </text>
        </svg>
      </VisibilitySensor>
    )
  }
}
export default class MainScroller extends React.Component {
  constructor(props) {
    super(props)
    this.WheelRef = React.createRef()
    this.bgref = React.createRef()
    this.scrollerRef = React.createRef()
    this.scrollContainer = React.createRef()
    this.CustomComponentRef = React.createRef()
    this.transitionAnimation = this.transitionAnimation.bind(this)
  }
  state = {
    pages: [
      "Start",
      "Distributed Teams",
      ".Net",
      "AWS",
      "NodeJS",
      "Angular",
      "C#",
      "Dev Ops",
      "iOS / Android",
      "Java",
      "PHP",
      "ReactJS",
      "Salesforce",
      "Insights",
    ],
    images: [
      "",
      banners["bg0"],
      banners["bg1"],
      banners["bg2"],
      banners["bg3"],
      banners["bg4"],
      banners["bg11"],
      banners["bg5"],
      banners["bg6"],
      banners["bg7"],
      banners["bg8"],
      banners["bg9"],
      banners["bg10"],
      "Insights",
    ],
    m_images: [
      "",
      banners["mbg0"],
      banners["mbg1"],
      banners["mbg2"],
      banners["mbg3"],
      banners["mbg4"],
      banners["mbg11"],
      banners["mbg5"],
      banners["mbg6"],
      banners["mbg7"],
      banners["mbg8"],
      banners["mbg9"],
      banners["mbg10"],
      "Insights",
    ],
    url: [
      "/distributed-teams",
      "/dotnet",
      "/aws",
      "/nodejs",
      "/angular",
      "/csharp",
      "/devops",
      "/ios",
      "/java",
      "/php",
      "/react",
      "/salesforce",
    ],
    scrollheight_: 0,
  }
  ChangeBackGroundImage = (index, isMobile) => {
    if (isMobile) {
      if (this.state.isTablet) {
        this.bgref.current.src = this.state.images[index]
        this.bgref.current.classList.remove("active")
        this.bgref.current.style.backgroundSize = "cover"
        this.bgref.current.style.backgroundRepeat = "no-repeat"
        this.bgref.current.style.backgroundPosition = "center center"
      } else {
        this.bgref.current.src = this.state.m_images[index]
        this.bgref.current.classList.remove("active")
        this.bgref.current.style.backgroundSize = "cover"
        this.bgref.current.style.backgroundRepeat = "no-repeat"
        this.bgref.current.style.backgroundPosition = "center -4.8vh"
        this.bgref.current.style.display = "block"
        this.bgref.current.style.transform = `scale(1.1)`
      }
    } else {
      // this.bgref.current.src = this.state.images[index]
      this.bgref.current.style.background = `url(${this.state.images[index]})`
      this.bgref.current.classList.remove("active")
      this.bgref.current.style.backgroundSize = "cover"
      this.bgref.current.style.backgroundRepeat = "no-repeat"
      this.bgref.current.style.backgroundPosition = "center center"
      this.bgref.current.style.display = "block"
    }
    // setTimeout(() => {
    //   // this.bgref.current.style.transform = `scale(${scale})`
    // }, 250)

    setTimeout(() => {
      if (this.bgref.current) {
        this.bgref.current.classList.add("active")
      }
    }, 750)
  }
  ChangeBackGroundToDefault = index => {
    this.bgref.current.style.background = `url(${gray_default})`
    this.bgref.current.style.backgroundSize = "cover"
    this.bgref.current.style.backgroundRepeat = "no-repeat"
    this.bgref.current.style.backgroundPosition = "center center"
    this.bgref.current.style.display = "none"
    this.bgref.current.classList.remove("active")
  }
  ExpertiseOnHover = event => {
    // .active-wrapper
    const selectedIndex = event.currentTarget.getAttribute("data-key")

    event.currentTarget.children[0].children[0].children[1].style.opacity = 1
    event.currentTarget.children[0].children[0].children[1].classList.add(
      "animated"
    )
    event.currentTarget.children[0].children[0].children[1].classList.add(
      "fadeInUp"
    )
    event.currentTarget.children[0].children[0].children[2].style.opacity = 1
    event.currentTarget.children[0].children[0].children[2].classList.add(
      "animated"
    )
    event.currentTarget.children[0].children[0].children[2].classList.add(
      "bounceInUp"
    )

    event.currentTarget.parentNode.classList.add("active-wrapper")
    event.currentTarget.children[0].parentNode.style.background =
      "rgba(89, 89, 89, 0.1)"

    if (selectedIndex === 0) {
    } else if (selectedIndex === 14) {
    } else {
      this.ChangeBackGroundImage(selectedIndex, false)
    }
  }
  ExpertiseOnMouseOut = event => {
    this.ChangeBackGroundToDefault()
    event.currentTarget.children[0].style.background = "none"
    event.currentTarget.children[0].parentNode.style.background = "none"
    event.currentTarget.children[0].children[0].children[1].style.opacity = 0
    event.currentTarget.children[0].children[0].children[1].classList.remove(
      "animated"
    )
    event.currentTarget.children[0].children[0].children[1].classList.remove(
      "fadeInUp"
    )
    event.currentTarget.children[0].children[0].children[2].style.opacity = 0
    event.currentTarget.children[0].children[0].children[2].classList.remove(
      "animated"
    )
    event.currentTarget.children[0].children[0].children[2].classList.remove(
      "bounceInUp"
    )
    event.currentTarget.parentNode.classList.remove("active-wrapper")
  }
  InsightOnMouseOut = event => {
    event.currentTarget.style.background = "none"
  }
  InsightOnHover = event => {
    event.currentTarget.style.background = "rgba(89, 89, 89, 0.1)"
  }
  componentDidMount() {
    window.addEventListener("wheel", this.wheelHandle, { passive: false })
  }
  componentWillUnmount() {
    window.removeEventListener("wheel", this.wheelHandle, { passive: false })
  }
  onError = () => {
    if (!this.state.errored) {
      this.setState({
        src: this.props.fallbackSrc,
        errored: true,
      })
    }
  }
  wheelHandle = event => {
    event.preventDefault()

    if (this.scrollerRef.current) {
      const currentScrollDelta = this.scrollerRef.current.getScrollLeft()
      var mdelta = event.deltaY / 2
      if (browserHandler.name === "firefox") {
        mdelta = event.deltaY * 15
      }
      var scrollCount = currentScrollDelta + mdelta
      this.scrollerRef.current.scrollLeft(scrollCount)
    }
  }
  onResize = (width, height) => {
    // const isMainPage = isMainPageFunc(this.props);
    // console.log(`isMainPage ${isMainPage}`)

    this.setState({
      width: width,
      height: height,
    })
  }
  transitionAnimation = event => {
    const expertise_link = event.currentTarget.getAttribute("href")
    event.preventDefault()
    this.CustomComponentRef.current.classList.add("animated", "fadeOut")
    // this.scrollContainer.current.hScrollParent.classList.add("animated", "fadeOut")
    setTimeout(() => {
      navigate(expertise_link)
    }, 1000)
  }
  render() {
    const HoverAnimation = posed.div({
      hoverable: true,
      init: {
        paddingBottom: "7rem",
      },
      hover: {
        paddingBottom: "20rem",
      },
    })
    const InsightsAnimation = posed.div({
      hoverable: true,
      init: {
        background: "none",
      },
      hover: {
        background: "rgba(89, 89, 89, 0.1)",
      },
    })

    const ScrollRenderer = (index, item) => {
      var last_index = this.state.pages.length - 1
      var url_link = "/expertise" + this.state.url[index - 1]
      switch (index) {
        case 0: {
          return (
            <div className="main-page-first-tile" key={index}>
              <div className="main-page-first-wrapper">
                { 
                    isIE ? 
                        <h1> Prosource builds and manages amazing distributed teams for clients around the world.</h1> :
                        <h1>
                        Prosource builds and manages {" "}
                        <BrushAnimation title={"amazing"} />
                        distributed teams for clients around the world.
                        </h1>
                }
                <div className="main-page-first-foot-wrapper">
                  <Link to={"/about"} className="insights expertise__link">
                    <h2 className="home-page-about">
                      About Us
                      <img
                        src={ArrowSvg}
                        alt="arrow"
                        className="sub-title-arrow"
                      ></img>
                    </h2>
                  </Link>
                  <h4>Scroll to see more</h4>
                </div>
              </div>
            </div>
          )
        }
        case 1: {
          url_link = "/distributed-teams"
          return (
            <div className="page-item-wrapper" key={index}>
              <Link
                to={url_link}
                className="expertise__link"
                onClick={this.transitionAnimation}
                data-key={index}
                key={index}
                onMouseOver={this.ExpertiseOnHover}
                onMouseOut={this.ExpertiseOnMouseOut}
              >
                <HoverAnimation className="expertise-body">
                  <div className="expertise-label">
                    <div
                      className="expertise-title"
                      style={{ fontSize: "6rem" }}
                    >
                      {item}
                    </div>
                    <div className="expertise-details">
                      The next evolution of outsourcing
                    </div>
                    <div className="expertise-view-more">
                      View More{" "}
                      <img
                        src={ArrowSvg}
                        alt="arrow"
                        className="view-more-arrow"
                      ></img>
                    </div>
                  </div>
                </HoverAnimation>
              </Link>
            </div>
          )
        }
        case last_index: {
          return (
            <div className="page-item-wrapper" key={index}>
              <InsightsAnimation
                className="expertise-insight-wrapper"
                key={index}
                data-key={index}
              >
                <div className="expertise-body-insights" key={index}>
                  <Link
                    to={"/insights"}
                    className="insights expertise__link"
                    onClick={this.transitionAnimation}
                    onMouseOver={this.InsightOnHover}
                    onMouseOut={this.InsightOnMouseOut}
                  >
                    Insights
                  </Link>
                  <Link
                    to={"/contact"}
                    className="insights expertise__link"
                    onClick={this.transitionAnimation}
                    onMouseOver={this.InsightOnHover}
                    onMouseOut={this.InsightOnMouseOut}
                  >
                    Contact Us
                  </Link>
                </div>
              </InsightsAnimation>
            </div>
          )
        }
        default: {
          return (
            <div className="page-item-wrapper" key={index}>
              <Link
                to={url_link}
                className="expertise__link"
                onClick={this.transitionAnimation}
                data-key={index}
                key={index}
                onMouseOver={this.ExpertiseOnHover}
                onMouseOut={this.ExpertiseOnMouseOut}
              >
                <HoverAnimation className="expertise-body">
                  <div className="expertise-label">
                    {/* Expertise */}
                    <div className="expertise-title">{item}</div>
                    <div className="expertise-details">
                      {/* We have the most Amazing team all over the world. */}
                    </div>
                    <div className="expertise-view-more">
                      View More{" "}
                      <img
                        src={ArrowSvg}
                        alt="arrow"
                        className="view-more-arrow"
                      ></img>
                    </div>
                  </div>
                </HoverAnimation>
              </Link>
            </div>
          )
        }
      }
    }
    const SnapRenderer = (index, item) => {
      var last_index = this.state.pages.length - 1
      var url_link = "/expertise" + this.state.url[index - 1]
      if (index == 1) {
        url_link = "/distributed-teams"
      }
      switch (index) {
        case 0: {
          return (
            <div className="section" key={index}>
              <p className="mobile-expertise-body-intro">
                Prosource builds and manages&nbsp;
                <BrushAnimation title={"amazing"} /> distributed teams for
                clients around the world.
              </p>
              <p className="mobile-expertise-body-sub">
                <Link to={"/about"} className="insights expertise__link">
                  About Us
                  <img
                    src={ArrowSvg}
                    alt="arrow"
                    className="mobile-snap-arrow"
                  ></img>
                </Link>
              </p>
            </div>
          )
        }
        case 8:
        case 1: {
          return (
            <div className="section" key={index}>
              <Link
                to={url_link}
                className="expertise__link"
                onClick={this.transitionAnimation}
                data-key={index}
                key={index}
              >
                <h3 className="mobile-expertise-label long-text-label">
                  Expertise
                </h3>
                <h2 className="mobile-expertise-title">{item}</h2>
                <p className="mobile-expertise-details">
                  {/* We have the most Amazing team all over the world. */}
                </p>
                <h4 className="mobile-expertise-view-more">
                  View More
                  <img
                    src={ArrowSvg}
                    alt="arrow"
                    className="mobile-expertise-view-arrow"
                  ></img>
                </h4>
              </Link>
            </div>
          )
        }
        case last_index: {
          return (
            <div className="section" key={index}>
              <div
                className="page-item-wrapper"
                style={{ minWidth: "0px", display: "block" }}
                key={index}
              >
                <div className="expertise-body-insights" key={index}>
                  <Link
                    to={"/insights"}
                    className="insights-mobile expertise__link"
                    onClick={this.transitionAnimation}
                  >
                    Insights
                  </Link>
                  <Link
                    to={"/contact"}
                    className="insights-mobile  expertise__link"
                    onClick={this.transitionAnimation}
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          )
        }
        default: {
          return (
            <div className="section" key={index}>
              <Link
                to={url_link}
                className="expertise__link"
                onClick={this.transitionAnimation}
                data-key={index}
                key={index}
              >
                <h3 className="mobile-expertise-label">Expertise</h3>
                <h2 className="mobile-expertise-title">{item}</h2>
                <p className="mobile-expertise-details">
                  {/* We have the most Amazing team all over the world. */}
                </p>
                <h4 className="mobile-expertise-view-more">
                  View More
                  <img
                    src={ArrowSvg}
                    alt="arrow"
                    className="mobile-expertise-view-arrow"
                  ></img>
                </h4>
              </Link>
            </div>
          )
        }
      }
    }
    const snapItems = this.state.pages.map((item, i) => {
      return SnapRenderer(i, item)
    })
    const pageItems = this.state.pages.map((item, i) => {
      return ScrollRenderer(i, item)
    })

    const ScrollMenuRender = () => {
      return (
        <Scrollbars
          style={{
            width: "100vw",
            height: "100vh",
          }}
          renderTrackHorizontal={props => (
            <div {...props} className="track-horizontal" />
          )}
          renderThumbHorizontal={props => (
            <div {...props} className="thumb-horizontal" />
          )}
          thumbSize={350}
          ref={this.scrollerRef}
          autoHeight={false}
        >
          <HorizontalScroll
            ref={this.scrollContainer}
            key={"m_scroll"}
            style={{
              height: "100%",
              width: "100%",
              whiteSpace: "pre-wrap",
              overflow: "visible",
            }}
            reverseScroll={true}
          >
            {pageItems}
          </HorizontalScroll>
        </Scrollbars>
      )
    }
    const SnapMenuRender = () => {
      return (
        <div className="snaprenderer-wrapper">
          <ReactFullpage
            onLeave={(origin, destination, direction) => {}}
            render={({ state, fullpageApi }) => {
              if (state.initialized) {
                if (state.hasOwnProperty("lastEvent")) {
                  // console.log(state.origin.index)// eslint-disable-line no-console
                  var index = state.destination.index
                  this.ChangeBackGroundImage(index, true)
                }
              }
              return <div> {snapItems} </div>
            }}
          />
        </div>
      )
    }

    const CustomComponent = () => {
      const width = this.state.width
      const height = this.state.height
      if (width) {
        if (width >= tabletWidth) {
          return <ScrollMenuRender key="scrollmenurender" />
        } else if (width >= phoneWidth && width <= tabletWidth) {
          //landscape check
          this.state.isTablet = true
          if (width >= 300 && width <= 990) {
            if (height >= 150 && height <= 600) {
              return <ScrollMenuRender key="scrollmenurender" />
            } else {
              return <SnapMenuRender key="snapmenurenderer" />
            }
          } else {
            return <SnapMenuRender key="snapmenurenderer" />
          }
        } else if (width <= phoneWidth) {
          //landscape check
          if (width >= 300 && width <= 990) {
            if (height >= 150 && height <= 600) {
              return <ScrollMenuRender key="scrollmenurender" />
            } else {
              return <SnapMenuRender key="snapmenurenderer" />
            }
          } else {
            return <SnapMenuRender key="snapmenurenderer" />
          }
        } else {
          return <div></div>
        }
      } else {
        return <div></div>
      }
    }
    const BGDiv = () => {
      return (
        <img
          key="gmage"
          className="front-page-bg"
          //  style={this.state.loaded ? {} : {backgroundColor: '#DCC5CC'}}
          // onLoad={() => this.setState({imageloaded: true})}
          ref={this.bgref}
        />
      )
    }
    return (
      <div
        style={{
          block: "unset",
        }}
        ref={this.CustomComponentRef}
        className="animated fadeIn fullsizeDiv"
        key={"item-wrapper"}
      >
        <BGDiv key="bg"></BGDiv>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize}>
          <CustomComponent key="gcomponent" />
        </ReactResizeDetector>
      </div>
    )
  }
}
